// extracted by mini-css-extract-plugin
export default {"link":"link_link__UUolg"};